export default "__VITE_ASSET__CLqBmvra__"